import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const HolidayForm = ({ HolidayId, initialData, onSuccess }) => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [HolidayName, setHolidayName] = useState('');
     const [date, setHolidayDate] = useState('');
     const [loading, setLoading] = useState(false);
     const [error, setError] = useState('');
     const navigate = useNavigate();

     // ✅ Fill form if initialData is provided (edit mode)
     useEffect(() => {
          if (initialData) {
               if (initialData.holiday) setHolidayName(initialData.holiday);
               if (initialData.date) setHolidayDate(initialData.date);
          }
     }, [initialData]);

     const handleSubmit = async (e) => {
          e.preventDefault();
          if (!HolidayName.trim()) {
               setError('Holiday name is required');
               return;
          }
          setLoading(true);
          setError('');
          try {
               let url = '';
               let method = 'POST';
               let body = {};
               if (HolidayId) {
                    // ✅ Edit mode
                    url = `${baseUrl}/updateHolidayById/${HolidayId}`;
                    body = { holiday: HolidayName, date };
               } else {
                    // ✅ Create mode
                    url = `${baseUrl}/createHoliday`;
                    body = { holiday: HolidayName, date };
               }

               const response = await fetch(url, {
                    method,
                    headers: {
                         'Content-Type': 'application/json',
                         'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                    },
                    body: JSON.stringify(body),
               });

               const data = await response.json();

               if (data.status) {
                    toast.success(HolidayId ? 'Holiday updated successfully' : 'Holiday created successfully');
                    setTimeout(() => {
                         if (onSuccess) onSuccess();
                         navigate('/Holiday');
                    }, 1200); // Wait 1.2 seconds for toast to show
               } else {
                    toast.error(data.message || `Failed to ${HolidayId ? 'update' : 'create'} Holiday`);
                    setError(data.message || `Failed to ${HolidayId ? 'update' : 'create'} Holiday`);
               }
          } catch (err) {
               setError('Error connecting to server');
          } finally {
               setLoading(false);
          }
     };

     return (
          <form className="general-info-form" onSubmit={handleSubmit}>
               <div className="form-grid">
                    {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
                    <div className="form-floating">

                         <input
                              type="text"
                              className="form-control"
                              id="HolidayName"
                              placeholder=" "
                              autoComplete="off"
                              value={HolidayName}
                              onChange={(e) => setHolidayName(e.target.value)}
                              disabled={loading}
                         />
                         <label htmlFor="HolidayName">Holiday Name</label>

                    </div>
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control"
                              id="HolidayDate"
                              placeholder=" "
                              autoComplete="off"
                              value={date}
                              onChange={(e) => setHolidayDate(e.target.value)}
                              onFocus={e => e.target.type = 'date'}
                              onBlur={e => { if (!e.target.value) e.target.type = 'text'; }}

                              disabled={loading}
                         />
                         <label htmlFor="HolidayDate">Date</label>
                    </div>
               </div>

               <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ marginTop: '15px' }}
                    disabled={loading}
               >
                    {loading ? 'Saving...' : 'Save'}
               </button>
          </form>
     );
};

export default HolidayForm;
